import { InventObject } from './InventObject.ts'
import type { InventoryMapObjectData, InventoryMapObjectTypes } from '@/widgets'
import { point } from '@turf/turf'

export default class InventObjectPoint extends InventObject {
  constructor(objectData: InventoryMapObjectData, objectType: InventoryMapObjectTypes) {
    super(objectData, objectType)

    this.feature = point(objectData.coordinates[0], this.properties)
    this.geometry = this.feature.geometry
  }

  public transformCoords(coords: any) {
    return [coords]
  }

  public getLabelCoords(): number[] {
    return this.getMapCoords() as number[]
  }
}
